import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class BaladyApiSetting
 *
 * @property {number} id
 */
export class BaladyApiSetting extends Model {


}

AccessorsMutatorsDecorator('id', 'property_id', 'api_key', 'manual_sending', 'day_of_month', 'sending_time', 'is_active')(BaladyApiSetting);



// WEBPACK FOOTER //
// ./src/pms-api/models/balady-api-setting.model.js